import {ReactNode} from 'react';
import ReactDOM from 'react-dom';
import {CloseOutlined} from '@ant-design/icons';

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    children: ReactNode;
}

export const Modal: React.FC<ModalProps> = ({isOpen, onClose, children}) => {
    if (!isOpen) return null;

    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        // Проверяем, что клик был именно по оверлею, а не по содержимому модального окна
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return ReactDOM.createPortal(
        <div style={styles.overlay} onClick={handleOverlayClick}>
            <div style={styles.modal}>
                <button style={styles.closeButton} onClick={onClose}>
                    <CloseOutlined />
                </button>
                {children}
            </div>
        </div>,
        document.body,
    );
};

const styles: {[key: string]: React.CSSProperties} = {
    overlay: {
        zIndex: 100,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    modal: {
        backgroundColor: '#fff',
        padding: '40px',
        margin: '20px',
        borderRadius: '32px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        position: 'relative',
        minWidth: '400px',
        maxWidth: '862px',
        minHeight: '400px',
    },
    closeButton: {
        position: 'absolute',
        top: '26px',
        right: '26px',
        border: 'none',
        background: 'none',
        fontSize: '20px',
        cursor: 'pointer',
    },
    openButton: {
        padding: '10px 20px',
        fontSize: '16px',
        cursor: 'pointer',
        borderRadius: '4px',
        border: '1px solid #ccc',
    },
    closeModalButton: {
        marginTop: '20px',
        padding: '10px 20px',
        fontSize: '16px',
        cursor: 'pointer',
        borderRadius: '4px',
        border: '1px solid #ccc',
    },
};
